import { TrendingDown, TrendingFlat, TrendingUp } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { AnimatedNumber } from '../../../common/components/AnimatedNumber';

type Props = {
  percentage: number;
  value: number;
  suffix?: string;
  isPositiveTrendUp?: boolean;
};

const getDeltaIcon = (value: number, isPositiveTrendUp: boolean) => {
  if (value === 0) {
    return <TrendingFlat sx={{ color: 'text.primary' }} />;
  }

  const color = (value > 0 && isPositiveTrendUp) || (value < 0 && !isPositiveTrendUp) ? 'issues.passed' : 'issues.high';
  return value > 0 ? <TrendingUp sx={{ color }} /> : <TrendingDown sx={{ color }} />;
};

export const TrendInfo = (props: Props) => {
  const { isPositiveTrendUp = true, suffix = '', value, percentage } = props;
  const prefix = value >= 0 ? '+' : '';
  const percentageValue = Number.isNaN(percentage) ? 0 : Math.round(percentage);
  return (
    <Stack direction="row" gap={1} alignItems="center">
      {getDeltaIcon(value, isPositiveTrendUp)}
      <Typography variant="body2">
        <AnimatedNumber value={percentageValue} prefix={prefix} suffix="%" />
        {' ('}
        <AnimatedNumber value={value} prefix={prefix} suffix={suffix} />
        {')'}
      </Typography>
    </Stack>
  );
};
